import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { APPCONFIG, multiLanguageServerURL } from '../_store/appConfig';
import { AppConfigService } from '../_services/appConfigService';
import { CommonService } from '../_services/common.service';
import { UtilityService } from '../_services/utility.service';
import { DownloadService } from '../_services/downloadService';
import { Config } from '../_store';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {
  constructor(private utilityService: UtilityService, private commonService: CommonService, private downloadService: DownloadService) { }

  getData(req, interfaceName, getBuyerNames = false) {
    const getDataFn = this.utilityService.httpPost(req, this.commonService.getInterfaceUrl(interfaceName));
    if (!getBuyerNames) {
      return getDataFn;
    } else {
      return getDataFn.pipe(switchMap(data => {
        return this.getSellers().pipe(map(sellersData => {
          this.enhanceListDataForBuyerNames(sellersData, data.data);
          return data;
        }));
      }))
    }
  }

  getRequestWithLastAccessTime(prevTime) {
    return {
      maxUpdateDate: 0
    }
  }

  getList(req, listType, listProcessFunction) {
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl(listType)).pipe(switchMap(data => {
      console.log("get list");
      
      console.log(data);
      
      return this.getSellers().pipe(map(sellersData => {
        this.enhanceListDataForBuyerNames(sellersData, data.data);
        return listProcessFunction(Object.assign({}, data.data));
      }));
    }));
  }

  getSellers(req = {}) {
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('GETSELLERS')).pipe(map(data => {
      if (data.data && data.data.sellers) {
        data.data.sellers.forEach(seller => {
          if (seller.buyers) {
            seller.buyers.forEach(buyer => {
              if (buyer.buyerCode) {
                if (Array.isArray(buyer.buyerCode)) {
                  buyer.buyerCd = buyer.buyerCode[0];
                } else {
                  buyer.buyerCd = buyer.buyerCode;
                }
              }
            });
          }
        });
      }
      return data.data;
    }));
  }

  getAccountStatement(req) {
    const url = `${this.commonService.getInterfaceUrl('VIEW_ACC_STATEMENT')}?sellerCode=${req.sellerCode}&buyerCode=${req.buyerCode}&fromDate=${req.fromDate}&toDate=${req.toDate}`
    const fileName = `accountStatement.pdf`;
    this.downloadService.downloadFile(url, fileName, true, 'Account Statement').then(fileLocation => {
    });
    // return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('VIEW_ACC_STATEMENT')).pipe(map(data => {
    //   return this.utilityService.httpGet(url,{}).pipe(map(data => {
    //     return data.data;
    // }));
  }

  /**
   * Get Multi Languages supported from remote server
   */
  getSupportedLanguages() {
    console.log("getSupportedLanguages", multiLanguageServerURL);
    return this.utilityService.httpGet(multiLanguageServerURL, {}).pipe(map(data => {
      return data.SupportedLanguages;
    }));
  }

  getDocViewPathForViewInv(docToView) {
    const data = docToView.fetchDocUriReq;
    const req = {
      maxUpdateDate: "",
      bucketName: data.bucketName,
      s3Key: data.s3Key,
      docId: docToView.docId
    }
    return this.utilityService.httpPost(req, this.commonService.getInterfaceUrl('VIEW_INV_PATH')).pipe(map(data => {
      return data
    }));
  }

  getUISellerConfig() {
    const url = `${Config.dashboardServiceURL}/static/ui-seller-config.json`;
    return this.utilityService.httpGet(url, {}).pipe(
      map(
        response => {
          return response;
        }
      )
    );
  }

  private enhanceListDataForBuyerNames(sellers, listData) {
    try {
      const buyerMap = {};
      (sellers.sellers).forEach(seller => {
        if (seller.buyers && seller.buyers.length) {
          seller.buyers.forEach(buyer => {
            buyerMap[`${seller.sellerCode}_${buyer.buyerCd}`] = buyer.buyerNm;
          });
        }
      });
      ["invoices", "transactions", "creditNotes"].forEach(listKey => {
        if (listData[listKey]) {
          Object.keys(listData[listKey]).forEach(itemKey => {
            const item = listData[listKey][itemKey];
            const buyerNameCode = `${item.sellerCode}_${item.buyerCode}`;
            if (buyerMap[buyerNameCode]) {
              item.buyerName = buyerMap[buyerNameCode];
              item.buyerNameWithCode = `${item.buyerCode} - ${item.buyerName}`;
            } else {
              item.buyerNameWithCode = item.buyerCode;
            }
          });
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  getSellersListAndUIConfig() {
    return this.getSellers({}).pipe(
      switchMap(sellersList => {
        return this.getUISellerConfig().pipe(map(sellersUIConfig => {
          sellersList.sellers.forEach(seller => {
            Object.assign(seller, sellersUIConfig[seller.sellerCode] || {});
          });
          return sellersList.sellers;
        }))
      })
    );
  }

  getSellersFromAPI(paymentMethod = "XiCard") {
    // let paymentMethod = "XiCard"
    return this.utilityService.httpPost({ paymentMethod }, this.commonService.getInterfaceUrl('PAYMENT_METHOD_SELLER')).pipe(map(data => {
      return data;
    }))
  }

  //TODO
  // Merge this function with getUISellerConfig
  getUIConfigBySellerCode(sellerCode) {
    const url = `${Config.dashboardServiceURL}/collection-data/ui-config`;
    return this.utilityService.httpPost({ sellerCode }, url).pipe(
      map(
        response => {
          return response;
        }
      )
    );
  }

}
